import * as Sentry from '@sentry/nextjs'
import posthog from 'posthog-js'

type BrowserInstrumentationOptions = {
  sentryConfig: Parameters<typeof Sentry.init>[0]
  isProduction: boolean
  posthogKey: string
  // Override Sentry's replay integration options per app (e.g. control wants
  // `maskAllText: false`). Defaults to no override.
  replayIntegrationOptions?: Parameters<typeof Sentry.replayIntegration>[0]
}

// Initialise Sentry + PostHog in the browser. Called as a side-effect from each
// app's `instrumentation-client.ts`.
export const initBrowserInstrumentation = ({
  sentryConfig,
  isProduction,
  posthogKey,
  replayIntegrationOptions,
}: BrowserInstrumentationOptions): void => {
  Sentry.init({
    ...sentryConfig,
    replaysSessionSampleRate: isProduction ? 0.1 : 0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [Sentry.replayIntegration(replayIntegrationOptions)],
  })

  posthog.init(posthogKey, {
    // Arbitrary choice of api route name, default ingest gets blocked by adblock
    api_host: '/gulp',
    ui_host: 'https://eu.posthog.com',
    // Weirdly needs to be exact date to not use legacy behaviour
    // https://posthog.com/docs/libraries/js/config
    defaults: '2026-01-30',
    capture_exceptions: true,
    debug: process.env.NODE_ENV === 'development',
  })
}

// Re-exported so each app's `instrumentation-client.ts` can hand it back to
// Next.js without importing @sentry/nextjs directly.
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
